module.exports = __webpack_public_path__ + "static/media/Seel_gaussian2.dc8d8783.png";